import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode'

import { Alert } from '@shoflo/polymer/components/Alert/Alert';
import { verifyUserEmail } from 'actions/user';

import ModalPage from 'containers/pages/ModalPage/ModalPage';

export const DELAY = 3000;

export const verificationStates = {
  warning: {
    type: 'warning',
    title: 'This verification link is invalid',
    content: `Reach out to app support if you're having trouble getting your email verified.`,
  },
  success: {
    type: 'success',
    title: 'Your email address has been verified',
    content: `In a moment you will be redirected to your application dashboard.`,
  },
  basic: {
    type: 'basic',
    title: 'Final step to getting you all set up!',
    content: `Hang on while we verify your email address`,
  },
};

const VerifyUserEmail = () => {
  const dispatch = useDispatch();
  const timeoutRef = useRef(null);

  const { token: verificationToken } = useParams();
  const emailVerified = useSelector((state) => state.emailVerified);
  const [invalidJWT, setInvalidJWT] = useState(false);

  useEffect(() => {
    /** if no verification token...return */
    if (!verificationToken) return;
    if (jwtDecode(verificationToken)) {
      dispatch(verifyUserEmail(verificationToken));
    } else {
      setInvalidJWT(true);
    }
  }, [verificationToken]);

  useEffect(() => {
    if (emailVerified) {
      // Clear any existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        window.location.assign('/dash/redirect');
      }, DELAY);
    }

    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current);
    };
  }, [emailVerified]);

  const alertProps = useMemo(() => {
    if (invalidJWT || (emailVerified !== null && !emailVerified))
      return verificationStates.warning;

    if (emailVerified) return verificationStates.success;

    return verificationStates.basic;
  }, [invalidJWT, emailVerified]);

  return (
    <ModalPage header="Verify Email">
      <Alert {...alertProps} />
    </ModalPage>
  );
};

export default VerifyUserEmail;
